import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

// Route-level code splitting — each page ships as its own JS chunk.
// The initial bundle only pays for the router shell + AuthCallback (needed inline
// so the OAuth redirect hash is handled without an async wait).
import AuthCallback from "./pages/AuthCallback";

const Landing          = lazy(() => import("./pages/Landing"));
const Catalogue        = lazy(() => import("./pages/Catalogue"));
const AdminDashboard   = lazy(() => import("./pages/AdminDashboard"));
const PublicEnquiry    = lazy(() => import("./pages/PublicEnquiry"));
const AboutUs          = lazy(() => import("./pages/AboutUs"));
const PrivacyPolicy    = lazy(() => import("./pages/PrivacyPolicy"));
const ReturnsExchange  = lazy(() => import("./pages/ReturnsExchange"));
const TermsConditions  = lazy(() => import("./pages/TermsConditions"));
const MyOrders         = lazy(() => import("./pages/MyOrders"));

// Branded loader — shown for the ~100–300 ms it takes to fetch a lazy chunk.
function RouteLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#D4AF37]">
      <div className="font-serif-lux text-2xl tracking-wide animate-pulse">Loading…</div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Suspense fallback={<RouteLoader />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/catalogue" element={<Catalogue />} />
        <Route path="/catalogue/:slug" element={<Catalogue />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/returns" element={<ReturnsExchange />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/o/:eid" element={<PublicEnquiry />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
        {/* Global 404 — anything unknown (including old-domain URLs) goes to catalogue. */}
        <Route path="*" element={<Navigate to="/catalogue" replace />} />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  // Kill long-press "Save image / Open in new tab" popup globally.
  // Runs once — captures every image contextmenu before it can bubble.
  React.useEffect(() => {
    const kill = (e) => {
      if (e.target && e.target.tagName === "IMG") e.preventDefault();
    };
    document.addEventListener("contextmenu", kill);
    return () => document.removeEventListener("contextmenu", kill);
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}
